import {useFormContext} from "react-hook-form";
import {Grid, InputLabel, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import {MuiRhfTextField} from "./MuiRhfTextField";
import React from "react";
import {wideFormFieldStyles} from "./UseWideFormFieldStyles";

export function WideFormTextField(props: {
  name: string,
  label: string,
  value?: string,
  readonly?: boolean
}) {
  const {getValues} = useFormContext();
  const theme = useTheme();

  return (
    <Grid container={true} sx={wideFormFieldStyles(theme).container}>
      <Grid item={true} xs={4} lg={3} xl={2} sx={wideFormFieldStyles(theme).labelContainer}>
        <InputLabel htmlFor={props.name} sx={wideFormFieldStyles(theme).label}>{props.label}</InputLabel>
      </Grid>
      <Grid item={true}>
        {props.readonly &&
          <Typography variant={"body1"} sx={wideFormFieldStyles(theme).value}>{getValues(props.name) || props.value}</Typography>
        }
        {!props.readonly &&
          <MuiRhfTextField
            id={props.name}
            name={props.name}
            fullWidth={false}
            variant="standard"
            label={''}
            disabled={props.readonly}
            InputLabelProps={{shrink: true}}
          />
        }
      </Grid>
    </Grid>
  )
}
